import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useResetPasswordMutation } from "../../actions/authActions";
import { useSelector } from "react-redux";
import textWeight from "../../utils/textWeight";

export default () => {
  const [loading, setLoading] = useState("");
  const navigate = useNavigate();
  const { TextWeight } = textWeight();
  const emailVerified = useSelector(
    (state) => state.app.emailVerified.emailVerified
  );
  const {
    handleSubmit,
    getValues,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      password: "",
      confirmPassword: "",
    },
  });

  const mutation = useResetPasswordMutation(setLoading, navigate);

  const onSubmit = (data, e) => {
    e.preventDefault();
    setLoading(true);
    mutation.mutate({
      email: emailVerified,
      password: data.password,
      password_confirmation: data.confirmPassword,
    });
  };
  return {
    TextWeight,
    handleSubmit,
    onSubmit,
    control,
    errors,
    getValues,
    loading,
  };
};
